// extracted by mini-css-extract-plugin
export default {"cell":"styles_cell__kz9Ao"};